<div class="item-container">
    <div class="item-header">
        <h5 class="text-center">{{"COMMON.EDIT" | translate}} Break Time</h5>
        <div class="edit-icons" (click)="onCancel()">
            <i class="material-icons">close</i>
        </div>
    </div>
    <div class="item-content d-flex flex-column justify-content-center">
        <form action="" [formGroup]="form" >
            <label class="mt-3">Start Time</label>
            <input type="text" mask="Hh:m0:s0" class="form-control" formControlName="br_tii"
                [dropSpecialCharacters]="false" [showMaskTyped]="true" />
            <label class="mt-3">End Time</label>
            <input type="text" mask="Hh:m0:s0" class="form-control" formControlName="br_tio"
                [dropSpecialCharacters]="false" [showMaskTyped]="true" />
        </form>
    </div>
    <div class="row">
        <div class="col-md-6 m-auto">
            <button mat-raised-button color="primary" class="auth-form-btn mt-3 mt-lg-4" type="submit"
            (click)="saveBreakTime()"
            >{{ "BUTTON.SAVE" | translate }}</button>
        </div>
    </div>
</div>
<app-loading-spinner></app-loading-spinner>